module.exports = __webpack_public_path__ + "media/images/svgs/close-11e1e7d7794255672e35010c08cf2c02.svg";